import { ImagePicture } from 'approot/shared/images/images';

import contentTeacherAvif from './content-teacher.avif';
import contentTeacherWebp from './content-teacher.webp';
import contentTeacherPng from './content-teacher.png';

const ImageContentTeacher = ({
  width,
  lazyLoad = true,
}: {
  width?: number;
  lazyLoad?: boolean;
}) => (
  <ImagePicture
    lazyLoad={lazyLoad}
    style={width ? { width } : undefined}
    avif={{ path: contentTeacherAvif }}
    webp={{ path: contentTeacherWebp }}
    png={{ path: contentTeacherPng }}
  />
);

export default ImageContentTeacher;
